import { Directive } from '@angular/core';

@Directive({
  selector: 'div[csContent]',
  standalone: false
})
export class ContentDirective {}
